import { render, staticRenderFns } from "./statistics_data.vue?vue&type=template&id=c384def8&lang=pug"
import script from "./statistics_data.vue?vue&type=script&lang=js"
export * from "./statistics_data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports